import { Pipe, PipeTransform } from '@angular/core';
import { Source } from '@jms/model';

@Pipe({
    name: 'sourceIcon',
    standalone: true
})
export class SourceIconPipe implements PipeTransform {

    transform(value: Source): string {

        switch (value) {
            case Source.Web:
                return 'fa-database';
            case Source.ContractorPortal:
                return 'fa-truck';
            case Source.ClientPortal:
                return 'fa-industry';
            case Source.Mobile:
                return 'fa-mobile';
        }

    }
}